module.exports = __webpack_public_path__ + "img/SKWINKELNetActieActieplanningE2A637.f7be374d.png";